import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export default function RouteError() {
  const err = useRouteError();
  if (isRouteErrorResponse(err)) {
    return (
      <div className="p-6 text-sm text-rose-300">
        Route error {err.status}: {err.statusText}
      </div>
    );
  }
  return (
    <pre className="p-6 text-xs text-rose-300/90">
      {String((err as Error)?.message || err)}
    </pre>
  );
}
